(ns app.front.view.admin.commands.mass-delete-domain-group-properties
  (:require [app.front.ui :as ui]
            [app.front.view.admin.common :as admin-common]
            [app.front.view.group.admin.common :as acommon]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(rf/reg-event-fx ::mass-delete-properties
  (fn [_ [_ domain-group-id]]
    {:comm/command {:command    :admin/mass-delete-domain-group-properties
                    :data       (util/mmap domain-group-id)
                    :on-success [::mass-delete-properties.success]}}))

(rf/reg-event-fx ::mass-delete-properties.success
  (fn [_ [_ _ {:keys [result]}]]
    {:dispatch [:notifications/add :toast :success :success result]}))

(defn view [match]
  (r/with-let [*selected-group (r/atom nil)]
    (let [tr (<sub [:tr])]
      [acommon/admin-page-v2 (util/mmap {:title "Mass-delete domain group properties"} match)
       [:section
        [ui/help
         (str "Deletes properties imported for a domain group that don't have any important information "
              "associated with them - the same limitations as the property mass-delete command in the property "
              "dashboard search view: no linked workspaces, licences, businesses or complaints, no uploaded "
              "attachments, and no property attributes. The deletion runs asynchronously in small batches so it "
              "does not overwhelm the system, check the logs for progress. "
              "This tool is not available to be used in production.")]
        [:div.flex.items-end.m-4
         [:div.w-1-2.xxl:w-2-5
          [admin-common/group-selector {:tr                  tr
                                        :groups-subscription [:core.front.admin/domain-groups]
                                        :on-change           #(reset! *selected-group %)}]]
         [:div.ml-4
          [ui/modal-confirmation-button
           (util/mmap {:on-yes-click        (fn [_]
                                              (>evt [::mass-delete-properties (:id @*selected-group)])
                                              (reset! *selected-group nil))
                       :trigger-button-opts {:size     :field
                                             :disabled (nil? @*selected-group)}
                       :trigger-button-text "Delete properties"}
                      tr)
           [:p "Delete properties without important information from domain group: "
            [:span.bold (:label @*selected-group)]]]]]]])))

(def route
  {:name        :view/admin.commands.mass-delete-domain-group-properties
   :own-layout? true
   :view        view})
